import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { IonLoading } from '@ionic/vue';
    import { onMounted, onUnmounted, ref } from 'vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'LoadingProvider',
  setup(__props) {

    const isLoading = ref(false);

    const handleLoadingStart = () => {
        isLoading.value = true;
    };

    const handleLoadingStop = () => {
        isLoading.value = false;
    };

    onMounted(() => {
        window.addEventListener('api-loading-start', handleLoadingStart);
        window.addEventListener('api-loading-stop', handleLoadingStop);
    });

    onUnmounted(() => {
        window.removeEventListener('api-loading-start', handleLoadingStart);
        window.removeEventListener('api-loading-stop', handleLoadingStop);
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonLoading), {
    "is-open": isLoading.value,
    spinner: "crescent"
  }, null, 8, ["is-open"]))
}
}

})